module.exports = __webpack_public_path__ + "images/emoji/tropical_fish.f3c6ca57833bc5927424.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tropical_fish.png
// module id = g+G1
// module chunks = 2